import { render } from "./App.vue?vue&type=template&id=6200a91c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6200a91c&lang=css"
script.render = render

export default script